var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkatheights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52 52",
    style: {
      enableBackground: "new 0 0 52 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#232A2E;}\r\n\t.st2{fill:none;}\r\n\t.st3{fill:#222A2D;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "35.13,30.49 26,26.01 16.87,30.49 26,34.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "34.15,20.91 17.85,20.91 26,24.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "26,35.68 18.03,39.26 33.97,39.26  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.84,
    y: 7.74,
    className: "st0",
    width: 4.27,
    height: 8.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.94,
    y: 7.74,
    className: "st0",
    width: 5.15,
    height: 8.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.84,
    y: 3.91,
    className: "st0",
    width: 24.22,
    height: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.06,17.08h-5.63c-0.01,0-0.02,0-0.02,0h-3.82c-0.01,0-0.02,0-0.02,0h-6.1c-0.01,0-0.02,0-0.02,0h-3.82 c-0.01,0-0.02,0-0.02,0h-4.74v2.82h24.22V17.08z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.91,
    y: 7.74,
    className: "st0",
    width: 5.15,
    height: 8.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.61,40.26H6.55v6.65h4.43c0.25-2.02,1.95-3.59,4.03-3.59c2.09,0,3.8,1.57,4.05,3.59h14.52 c0.25-2.02,1.95-3.59,4.03-3.59c2.09,0,3.79,1.57,4.05,3.59h3.79v-6.65h-3.06H9.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.17,33.12c-1.26,0-2.28,1.07-2.28,2.38v3.75h-5.47l-9.2-4.13l9.29-4.17c0.18-0.08,0.29-0.25,0.29-0.45 c0-0.19-0.11-0.37-0.28-0.46l-9.39-4.6l9.29-4.55h2.13c0,0,0.01,0,0.01,0h3.82c0.28,0,0.5-0.22,0.5-0.5v0v-3.82V7.24V3.41v-0.5 c0-1.33-1.08-2.41-2.41-2.41s-2.41,1.08-2.41,2.41H13.84c0-1.33-1.08-2.41-2.41-2.41S9.02,1.58,9.02,2.91v17.5 c0,0.28,0.22,0.5,0.5,0.5h3.82c0,0,0.01,0,0.01,0h2.22l9.29,4.55l-9.39,4.6c-0.17,0.09-0.28,0.26-0.28,0.46 c0,0.19,0.12,0.37,0.29,0.45l9.29,4.17l-9.2,4.13h-5.47v-3.75c0-1.32-1.02-2.38-2.28-2.38s-2.28,1.07-2.28,2.38v4.25v7.65 c0,0.28,0.22,0.5,0.5,0.5h4.93c0.24,2.02,1.95,3.59,4.03,3.59c2.09,0,3.81-1.57,4.05-3.59h14.52c0.24,2.02,1.95,3.59,4.03,3.59 c2.09,0,3.81-1.57,4.05-3.59h4.28c0.28,0,0.5-0.22,0.5-0.5v-7.65v-4.25C46.45,34.19,45.42,33.12,44.17,33.12z M38.06,16.08h-5.15 V7.74h5.15V16.08z M13.84,3.91h24.22v2.82H13.84V3.91z M28.09,7.74v8.35h-5.15V7.74H28.09z M13.84,7.74h4.27v8.35h-4.27V7.74z  M13.84,19.91v-2.82h4.74c0.01,0,0.02,0,0.02,0h3.82c0.01,0,0.02,0,0.02,0h6.1c0.01,0,0.02,0,0.02,0h3.82c0.01,0,0.02,0,0.02,0 h5.63v2.82H13.84z M17.85,20.91h16.31L26,24.9L17.85,20.91z M16.87,30.49L26,26.01l9.13,4.47L26,34.59L16.87,30.49z M26,35.68 l7.97,3.58H18.03L26,35.68z M45.45,46.91h-3.79c-0.26-2.02-1.96-3.59-4.05-3.59c-2.07,0-3.77,1.57-4.03,3.59H19.06 c-0.26-2.02-1.96-3.59-4.05-3.59c-2.07,0-3.77,1.57-4.03,3.59H6.55v-6.65h3.06h32.77h3.06V46.91z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkatheights);
export default __webpack_public_path__ + "static/media/workatheights.ab4e1aece7366b5ebfdfa79c02a4db43.svg";
export { ForwardRef as ReactComponent };